/* eslint-disable eqeqeq */
// notificationHandler.js
import { toast } from "react-toastify";
import { activeNotification } from "../Redux/Slices/notificationSlice";
import { toastProperties } from "../commons/Toast/Toaster";
import {
  addNewCounterPartyBid,
  addNewCounterPartyListing,
  emptyCounterPartyList,
  fetchActiveConnection,
  fetchCounterPartList,
  fetchLedgerBids,
  fetchSearchListing,
  fetchSelfCapacity,
  fetchSelfCapacityById,
  setActiveListingId,
  updateActiveConnection,
  updateBidStatus,
  updateCounterListingData,
  updateCounterListingStatus,
  updateMainScreenData,
  updateSelfCapacityById,
} from "../Redux/Slices/CapacitySlice";
import { store } from "../Redux/store";
import {
  getConnectionDetails,
  getMainScreenConnectionDetails,
  getSelfCounterPartyListings,
} from "../Services/BuySell/Listing";
//
import {
  addNewCounterPartyListingBanking,
  fetchAllBankingListings,
  fetchLedgerBanking,
  fetchMatchmakingResults,
  fetchSearchBanking,
  updateBankingBidStatus,
  updateMatchesListingData,
  updateBankingMatchmakingData,
} from "../Redux/Slices/bankingSlice";
import { getMatchmakingResults } from "../Services/ApiCalling/banking";

async function refreshListingData(
  dispatch,
  state,
  notificationId,
  includeUpdateSelfCapacity = false,
  isClose = false,
) {
  console.log("🚀 ~ refreshListingData ~ notificationId:", notificationId);
  const user = JSON.parse(
    JSON.stringify(state?.persistedReducer?.userType),
  ).toLowerCase();

  const stateName = state?.persistedReducer?.company?.stateLabel;

  await new Promise((resolve) => setTimeout(resolve, 2000));

  if (window.location.pathname.includes("/search_listing")) {
    const aa = user === "consumer" ? "generator" : "consumer";

    // Parallel execution
    await Promise.all([
      dispatch(
        fetchSearchListing({
          user: aa,
          curr: 0,
          type: true,
          state: stateName,
          waitForBackend: true,
        }),
      ),
      dispatch(
        fetchSearchListing({
          user: aa,
          curr: 0,
          type: false,
          state: stateName,
          waitForBackend: true,
        }),
      ),
    ]);
    return;
  }

  if (includeUpdateSelfCapacity) {
    // Parallel execution
    const [, activeConnectionData] = await Promise.all([
      dispatch(updateSelfCapacityById()),
      getConnectionDetails(0, notificationId, null),
    ]);

    dispatch(
      updateActiveConnection(
        activeConnectionData?.data?.data?.page ||
          activeConnectionData?.data?.data,
      ),
    );
  }

  if (notificationId) {
    const payload = {
      id: notificationId,
      energySourceType: "",
      energyFuelType: "",
      tag: "",
    };

    if (isClose) {
      dispatch(setActiveListingId(null));
      dispatch(emptyCounterPartyList());
    }

    // Execute independent calls in parallel
    const [mainscreenData] = await Promise.all([
      getMainScreenConnectionDetails(notificationId),
      dispatch(fetchSelfCapacityById({ user, id: notificationId })),
      dispatch(
        fetchCounterPartList({ user, payload, curr: 0, showLoading: false }),
      ),
      dispatch(fetchLedgerBids(notificationId, { showLoading: false })),
      dispatch(fetchSelfCapacity({ user, showLoading: false })),
      dispatch(
        fetchActiveConnection({
          curr: 0,
          capId: notificationId,
          isTermsAccepted: null,
          showLoading: false,
        }),
      ),
    ]);

    dispatch(
      updateMainScreenData(
        mainscreenData?.data?.data?.page || mainscreenData?.data?.data,
      ),
    );
  }
}

async function handleConnectionRequestAccepted(
  dispatch,
  state,
  notificationId,
  data,
) {
  const activeListingId = state?.CapacitySlice?.activeListingId;
  if (String(activeListingId) !== String(notificationId)) return;

  dispatch(updateBidStatus(data?.data));
  await new Promise((resolve) => setTimeout(resolve, 2000));

  const mainscreenData = await getMainScreenConnectionDetails(activeListingId);
  dispatch(fetchLedgerBids(activeListingId));
  dispatch(
    updateMainScreenData(
      mainscreenData?.data?.data?.page || mainscreenData?.data?.data,
    ),
  );

  const payloadParams = {
    id: activeListingId,
    energySourceType: "",
    energyFuelType: "",
    tag: "",
  };
  const user = JSON.parse(
    JSON.stringify(state?.persistedReducer?.userType),
  ).toLowerCase();

  const counterData = await getSelfCounterPartyListings(user, payloadParams, 0);
  const payload =
    user === "consumer"
      ? counterData?.data?.data?.generatorList
      : counterData?.data?.data?.consumerList;

  dispatch(updateCounterListingData(payload));
}

async function refreshBankingListingData(
  dispatch,
  state,
  notificationId,
  includeUpdateSelfListing = false,
) {
  const user = JSON.parse(
    JSON.stringify(state?.persistedReducer?.userType),
  ).toLowerCase();

  const currentActiveListingId = state?.bankingSlice?.activeListingId;
  const listingIdToUse = currentActiveListingId || notificationId;
  if (!includeUpdateSelfListing && listingIdToUse) {
    dispatch(fetchMatchmakingResults({ id: listingIdToUse }));
  }

  dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));

  dispatch(fetchAllBankingListings());

  if (window.location.pathname.includes("/banking_search")) {
    dispatch(fetchSearchBanking({ current: true }));
  }
}

async function refreshMatchmakingData(dispatch, state) {
  const activeListingId = state?.bankingSlice?.activeListingId;
  if (activeListingId) {
    dispatch(
      fetchMatchmakingResults({
        id: activeListingId,
        statusFilter: null,
      }),
    );
  }
}

async function refreshBankingMatchmakingData(dispatch, activeListingId) {
  try {
    const matchmakingRes = await getMatchmakingResults(activeListingId);

    if (matchmakingRes?.data?.success && matchmakingRes?.data?.data) {
      const freshData = {
        matches: matchmakingRes.data.data.matches || [],
        selfListing: matchmakingRes.data.data.selfListing || null,
        ...matchmakingRes.data.data,
      };

      dispatch(updateBankingMatchmakingData(freshData));
    } else {
      console.error("Failed to fetch matchmaking data:", matchmakingRes);
      console.error("Response structure:", {
        success: matchmakingRes?.data?.success,
        hasData: !!matchmakingRes?.data?.data,
        fullResponse: matchmakingRes,
      });
    }
  } catch (error) {
    console.error("Error refreshing banking matchmaking data:", error);
  }
}

export async function handleNotification(dispatch, notification) {
  const { key, url, title, message, reload, data } = notification;

  toast.info(`${message}`, {
    ...toastProperties,
    onClick: () => {
      if (url) {
        window.location.href = `${window.location.origin}${url}`;
      }
    },
  });

  dispatch(activeNotification({ key, url, title, message, reload, data }));
  const state = store.getState();
  const currentPath = window.location.pathname;
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  let storeActiveId = state?.CapacitySlice?.activeListingId;
  if (!storeActiveId) {
    if (
      window.location.pathname.includes("/bilateral") ||
      window.location.pathname.includes("/ledger") ||
      window.location.pathname.includes("/ongoing") ||
      window.location.pathname.includes("/banking_search")
    ) {
      const urlParams = new URLSearchParams(window.location.search);
      storeActiveId = urlParams.get("id");
    }
  }

  const activeListingId = state?.bankingSlice?.activeListingId;
  if (activeListingId) {
    dispatch(
      fetchMatchmakingResults({
        id: activeListingId,
        statusFilter: null,
      }),
    );
  }

  const notificationUrl = url || "";
  const notificationUrlParams = new URLSearchParams(
    notificationUrl.split("?")[1],
  );
  const notificationId = notificationUrlParams.get("id");

  let bankingListingId = null;

  if (notification.key?.startsWith("BANKING")) {
    if (notification.data?.listingId) {
      bankingListingId = notification.data.listingId;

      const listingMatch = bankingListingId.match(/B(\d+)_/);
      if (listingMatch) {
        bankingListingId = listingMatch[1];
      }
    } else if (notification.data?.id) {
      bankingListingId = notification.data.id;
    } else if (notification.listingId) {
      bankingListingId = notification.listingId;
    } else if (notificationId) {
      bankingListingId = notificationId;
    }
  }

  if (reload) {
    switch (notification?.key) {
      case "BSBPConnectionRequestSent":
        if (currentPath === "/ledger") {
          const urlParams = new URLSearchParams(window.location.search);
          const id = urlParams.get("id");
          dispatch(fetchLedgerBids(id));
        }
        break;
      case "BSBPConnectionRequestReceived":
        if (currentPath === "/ledger") {
          const urlParams = new URLSearchParams(window.location.search);
          const id = urlParams.get("id");
          dispatch(fetchLedgerBids(id));
        }

        break;

      case "BSBPTACShared":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPListingCreatedToAllOtherParties":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPContractClosureNotification":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true, true);
        }
        break;
      case "BSBPDocumentSubmitted":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPTACWithdrawn":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPTACUpdated":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPListingUpdated":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPListingOnHold":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPDocumentRejected":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(
            dispatch,
            state,
            storeActiveId || notificationId,
            true,
          );
        }
        break;
      case "BSBPDocumentUploadedToSelf":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(
            dispatch,
            state,
            storeActiveId || notificationId,
            true,
          );
        }
        break;

      case "BSBPTACSharedReject":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPTACAllAccepted":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;

      case "BSBPListingWithdrawn":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPLisitngWithdrawnToCreator":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPLisitngUpdatedToCreator":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPLisitngOnHoldToCreator":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;

      case "BSBPTACRejection":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;
      case "BSBPTACAccepted":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;

      case "BSBPDocumentApproved":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, notificationId);
        }
        break;
      case "BSBPConsentDocumentUploaded":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, notificationId);
        }
        break;
      case "BSBPLdcDocumentUploaded":
        if (
          id == notificationId ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, notificationId, true);
        }
        break;

      case "BSBPDocumentUploaded":
        if (
          ((data?.documentType === "Final Agreement" ||
            data?.documentType === "LDC" ||
            data?.documentType === "STOA") &&
            id == notificationId) ||
          String(storeActiveId) == String(notificationId)
        ) {
          await refreshListingData(dispatch, state, notificationId, true);
        }

        break;

      //Banking notification
      case "BANKINGConnectionRequestReceived":
        const matchmakingDataReceived = state?.bankingSlice?.matchmakingData;
        const activeListingIdReceived = state?.bankingSlice?.activeListingId;
        const isOnBankingPageReceived =
          currentPath === "/banking" || currentPath === "/ledger";

        if (matchmakingDataReceived && data?.data) {
          const matchingBid = matchmakingDataReceived?.matches?.find(
            (match) => match.bidId === data.data.bidId,
          );

          if (
            matchingBid ||
            String(activeListingIdReceived) === String(data.data.id) ||
            matchmakingDataReceived?.selfListing?.id === data.data.id ||
            (isOnBankingPageReceived && activeListingIdReceived)
          ) {
            dispatch(
              updateMatchesListingData({
                bidId: data.data.bidId,
                status: data.data.status,
                id: data.data.id,
              }),
            );

            const listingIdToRefresh =
              activeListingIdReceived || bankingListingId;
            if (listingIdToRefresh) {
              await refreshBankingMatchmakingData(dispatch, listingIdToRefresh);
            }

            dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
            dispatch(fetchAllBankingListings());
          }
        }
        break;

      case "BANKINGConnectionRequestAccepted": {
        const matchmakingDataAccepted = state?.bankingSlice?.matchmakingData;
        // const activeListingIdAccepted = state?.bankingSlice?.activeListingId;
        const activeListingIdForTAC = state?.bankingSlice?.activeListingId;

        // if (matchmakingDataAccepted && data?.data) {
        // const matchingBid = matchmakingDataAccepted?.matches?.find(
        //   (match) => match.bidId === data.data.bidId
        // );

        if (
          id === bankingListingId ||
          String(activeListingIdForTAC) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse = activeListingIdForTAC || bankingListingId;

          if (String(activeListingIdForTAC) === String(bankingListingId)) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }
          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        // }

        break;
      }

      case "BANKINGTACShared":
        const activeListingIdForTAC = state?.bankingSlice?.activeListingId;

        if (
          id === bankingListingId ||
          String(activeListingIdForTAC) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse = activeListingIdForTAC || bankingListingId;

          if (String(activeListingIdForTAC) === String(bankingListingId)) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }
          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }

        break;

      case "BANKINGTACAccepted":
        const activeListingIdTACAccepted = state?.bankingSlice?.activeListingId;
        if (
          id === bankingListingId ||
          String(activeListingIdTACAccepted) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse = activeListingIdTACAccepted || bankingListingId;
          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;

      case "BANKINGTACDeclined":
        const activeListingIdTACDeclined = state?.bankingSlice?.activeListingId;
        if (
          id === bankingListingId ||
          String(activeListingIdTACDeclined) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse = activeListingIdTACDeclined || bankingListingId;

          if (String(activeListingIdTACDeclined) === String(bankingListingId)) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }
          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;

      case "BANKINGDocumentApproved":
        const activeListingIdDocApproved = state?.bankingSlice?.activeListingId;
        if (
          id === bankingListingId ||
          String(activeListingIdDocApproved) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse = activeListingIdDocApproved || bankingListingId;

          if (String(activeListingIdDocApproved) === String(bankingListingId)) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 5000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;

      case "BANKINGDocumentRejected":
        const activeListingIdDocRejected = state?.bankingSlice?.activeListingId;
        if (
          id === bankingListingId ||
          String(activeListingIdDocRejected) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse = activeListingIdDocRejected || bankingListingId;

          if (String(activeListingIdDocRejected) === String(bankingListingId)) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 5000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;

      case "BANKINGDocumentUploaded":
        if (
          data?.documentType === "Final Agreement" ||
          data?.documentType === "LDC" ||
          data?.documentType === "STOA"
        ) {
          const activeListingIdDocUploaded =
            state?.bankingSlice?.activeListingId;

          if (
            id === bankingListingId ||
            String(activeListingIdDocUploaded) === String(bankingListingId) ||
            bankingListingId
          ) {
            const listingIdToUse =
              activeListingIdDocUploaded || bankingListingId;

            if (
              String(activeListingIdDocUploaded) === String(bankingListingId)
            ) {
              const currentUrl = new URL(window.location.href);
              currentUrl.searchParams.set("id", bankingListingId);
              window.history.pushState({}, "", currentUrl.toString());

              setTimeout(() => {
                window.location.reload();
              }, 5000);
              return;
            }

            if (listingIdToUse) {
              await refreshBankingMatchmakingData(dispatch, listingIdToUse);
            }

            dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
            dispatch(fetchAllBankingListings());
          }
        }
        break;

      case "BANKINGConnectionRequestDeclined":
        // case "BANKINGConnectionRequestDeclinedSelf":
        const activeListingIdForListingDec =
          state?.bankingSlice?.activeListingId;
        if (
          id === bankingListingId ||
          String(activeListingIdForListingDec) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse =
            activeListingIdForListingDec || bankingListingId;

          if (
            String(activeListingIdForListingDec) === String(bankingListingId)
          ) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }

        break;
      case "BANKINGListingOnHold":
      case "BANKINGListingUpdated":
      case "BANKINGListingWithdrawn":
      case "BANKINGListingUpdatedToCreator":
        const activeListingIdForListing = state?.bankingSlice?.activeListingId;
        if (
          id === bankingListingId ||
          String(activeListingIdForListing) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse = activeListingIdForListing || bankingListingId;

          if (String(activeListingIdForListing) === String(bankingListingId)) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;
      case "BANKINGLedgerUpdated":
        const activeListingIdLedgerUpdated =
          state?.bankingSlice?.activeListingId;

        if (
          id === bankingListingId ||
          String(activeListingIdLedgerUpdated) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse =
            activeListingIdLedgerUpdated || bankingListingId;

          if (
            String(activeListingIdLedgerUpdated) === String(bankingListingId)
          ) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;
      case "BANKINGLedgerRejected":
        const activeListingIdLedgerRejected =
          state?.bankingSlice?.activeListingId;

        if (
          id === bankingListingId ||
          String(activeListingIdLedgerRejected) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse =
            activeListingIdLedgerRejected || bankingListingId;

          if (
            String(activeListingIdLedgerRejected) === String(bankingListingId)
          ) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;
      case "BANKINGLedgerApproved":
        const activeListingIdLedgerApproved =
          state?.bankingSlice?.activeListingId;

        if (
          id === bankingListingId ||
          String(activeListingIdLedgerApproved) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse =
            activeListingIdLedgerApproved || bankingListingId;

          if (
            String(activeListingIdLedgerApproved) === String(bankingListingId)
          ) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;
      case "BANKINGLedgerCreated":
        const activeListingIdLedgerCreated =
          state?.bankingSlice?.activeListingId;

        if (
          id === bankingListingId ||
          String(activeListingIdLedgerCreated) === String(bankingListingId) ||
          bankingListingId
        ) {
          const listingIdToUse =
            activeListingIdLedgerCreated || bankingListingId;

          if (
            String(activeListingIdLedgerCreated) === String(bankingListingId)
          ) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("id", bankingListingId);
            window.history.pushState({}, "", currentUrl.toString());

            setTimeout(() => {
              window.location.reload();
            }, 1000);
            return;
          }

          if (listingIdToUse) {
            await refreshBankingMatchmakingData(dispatch, listingIdToUse);
          }

          dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
          dispatch(fetchAllBankingListings());
        }
        break;
      default:
        break;
    }
  } else {
    switch (notification?.key) {
      case "BSBPConnectionRequestAccepted":
        await handleConnectionRequestAccepted(
          dispatch,
          state,
          notificationId,
          data,
        );
        break;
      case "BSBPBidWithdrawn":
        await handleConnectionRequestAccepted(
          dispatch,
          state,
          notificationId,
          data,
        );
        break;
      case "BSBPConnectionRequestDeclined":
        await handleConnectionRequestAccepted(
          dispatch,
          state,
          notificationId,
          data,
        );
        break;
      case "BSBPConnectionRequestReceived":
        const consumerName =
          data?.data?.consumerName || data?.data?.generatorName || "";

        if (
          store.getState()?.CapacitySlice?.activeMain?.name === consumerName
        ) {
          dispatch(
            updateCounterListingStatus({
              id: data?.data?.consumer?.id || data?.data?.generator?.id,
              status: data?.data?.status || data?.data?.status,
            }),
          );

          dispatch(addNewCounterPartyBid(data?.data));
        }
        break;
      case "BSBPListingCreatedToMatchingParties":
        if (
          data?.data?.matchedListingNames?.includes(
            state?.CapacitySlice?.activeMain?.name,
          ) &&
          currentPath === "/dashboard"
        ) {
          dispatch(addNewCounterPartyListing(data?.data?.createdListing));
          await refreshListingData(dispatch, state, storeActiveId, true);
        } else if (currentPath === "/search_listing") {
          await refreshListingData(dispatch, state, storeActiveId, true);
        }
        break;

      //banking notification
      case "BANKINGListingCreatedToMatchingParties":
        const matchmakingData = state?.bankingSlice?.matchmakingData;
        const activeListingId = state?.bankingSlice?.activeListingId;
        const activeListingName = matchmakingData?.selfListing?.name;
        const activeListingSelfId = matchmakingData?.selfListing?.id;

        if (
          (activeListingId &&
            (String(activeListingId) === String(activeListingSelfId) ||
              data?.data?.matchedListingNames?.includes(activeListingName))) ||
          currentPath === "/banking"
        ) {
          dispatch(addNewCounterPartyListingBanking(data?.data?.listingData));
        }
        break;

      case "BANKINGConnectionRequestReceived":
        const matchmakingDataReceived = state?.bankingSlice?.matchmakingData;
        const activeListingIdReceived = state?.bankingSlice?.activeListingId;
        const isOnBankingPageReceived =
          currentPath === "/banking" || currentPath === "/ledger";

        if (matchmakingDataReceived && data?.data) {
          const matchingBid = matchmakingDataReceived?.matches?.find(
            (match) => match.bidId === data.data.bidId,
          );

          if (
            matchingBid ||
            String(activeListingIdReceived) === String(data.data.id) ||
            matchmakingDataReceived?.selfListing?.id === data.data.id ||
            (isOnBankingPageReceived && activeListingIdReceived)
          ) {
            dispatch(
              updateMatchesListingData({
                bidId: data.data.bidId,
                status: data.data.status,
                id: data.data.id,
              }),
            );

            if (activeListingIdReceived) {
              await refreshBankingMatchmakingData(
                dispatch,
                activeListingIdReceived,
              );
            }
          }
        }
        break;

      case "BANKINGConnectionRequestAccepted":
        const matchmakingDataAAccepted = state?.bankingSlice?.matchmakingData;
        const activeListingIdAccepted = state?.bankingSlice?.activeListingId;
        const isOnBankingPageAccepted =
          currentPath === "/banking" || currentPath === "/ledger";

        if (matchmakingDataAAccepted && data?.data) {
          const matchingBid = matchmakingDataAAccepted?.matches?.find(
            (match) => match.bidId === data.data.bidId,
          );

          if (
            matchingBid ||
            String(activeListingIdAccepted) === String(data.data.id) ||
            matchmakingDataAAccepted?.selfListing?.id === data.data.id ||
            (isOnBankingPageAccepted && activeListingIdAccepted)
          ) {
            // First update the specific bid status
            dispatch(
              updateBankingBidStatus({
                bidId: data.data.bidId,
                status: data.data.status,
                id: data.data.id,
              }),
            );

            // Then use simple refresh for data update
            const listingIdToRefresh =
              activeListingIdAccepted || bankingListingId;
            if (listingIdToRefresh) {
              await refreshBankingMatchmakingData(dispatch, listingIdToRefresh);
            }

            // Refresh other banking data
            dispatch(fetchLedgerBanking({ currentPage: 0, size: 20 }));
            dispatch(fetchAllBankingListings());
          }
        }
        break;

      default:
        break;
    }
  }
}
